import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import { Loader } from '../Loader';
import { Error } from '../Error';
import { NoResult } from '../NoResult';

import Widget, { WidgetTitle, WidgetContent } from './Widget';
import Clear from '../Clear';
import Select from '../forms/Select';

function CarPartsSortWidget({ location, history }) {
  const query = qs.parse(location.search, { arrayFormat: 'bracket' });
  const orderBy = query.orderBy || undefined;

  const onSearchSumbit = event => {
    console.log('search submitted', event);
  };

  const handleChange = data  => {
    history.push({
        pathname: '/bildeler/',
        search: qs.stringify(
          {
            ...query,
            orderBy: data.value
          },
          { arrayFormat: 'bracket' }
        )
      });
  };

  const handleClear = () => {
    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          orderBy: undefined
        },
        { arrayFormat: 'bracket' }
      )
    });
  };

  const orderOptionItems = [
    {
      value: 'priceAsc',
      label: 'Pris (lav til høy)'
    },
    {
      value: 'priceDesc',
      label: 'Pris (høy til lav)'
    }
  ];

  return (
    <Widget>
      <WidgetTitle>Sorter på</WidgetTitle>
      <WidgetContent>
        <Clear onClearClick={handleClear} />

        <Select
          items={orderOptionItems}
          name="orderBy"
          label="Sortér på"
          hideLabel={true}
          value={orderOptionItems.find(orderOption => orderOption.value === orderBy)}
          placeholder="Sortering"
          onSelectChange={handleChange}
        />
      </WidgetContent>
    </Widget>
  );
}

export default withRouter(CarPartsSortWidget);
